import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router";
import { pxToRem } from "../../design/utils";
import { GridItem, GridWrapper } from "../bits/layout/Grid";
import { ManagementViewHeader } from "../patterns/ManagementViewHeader";
import { ManagementViewMenu } from "../patterns/managementViewMenu";

const SidePanel = styled(GridItem)<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 200px;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    position: fixed;
    top: ${pxToRem(52)};
    left: 0;
    width: 90%;
    max-width: 250px;
    height: calc(100vh - ${pxToRem(52)});
    height: calc(100dvh - ${pxToRem(52)});
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);
    transform: ${({ isOpen }) =>
      isOpen ? "translateX(0)" : "translateX(-100%)"};
    transition: transform 0.3s ease-in-out;
    z-index: 10;
  }
`;

export const ManagementView = () => {
  const [sidePanelOpen, setSidePanelOpen] = useState(true);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <GridWrapper>
      <ManagementViewHeader
        setSidePanelOpen={setSidePanelOpen}
        sidePanelOpen={sidePanelOpen}
      />

      <SidePanel span={3} isOpen={sidePanelOpen}>
        <ManagementViewMenu />
      </SidePanel>
      <GridItem
        span={9}
        css={({ breakpoints }) => css`
          @media (max-width: ${breakpoints.values.lg}px) {
            grid-column: span 12;
          }
        `}
        ref={scrollRef}
        style={{ overflow: "auto", scrollbarWidth: "thin" }}
      >
        <Outlet />
      </GridItem>
    </GridWrapper>
  );
};
